module.exports = __webpack_public_path__ + "static/media/simple.ee045eb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/News/Assets/simple.png
// module id = 377
// module chunks = 0